import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfPF",
  "use": "BankOfPF-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 68\" id=\"BankOfPF\">\r\n<defs>\r\n    <style>\r\n      #BankOfPF .cls-1 {\r\n        fill: #1d2088;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfPF_浦发logo\" class=\"cls-1\" d=\"M3464.9,761.453c-6.37-12.5-22.48-10.588-26.02.05,0,0-.49,3.449-0.88,7.037v21.8L3448.35,800V773.4s1.12-12.719,16.55-11.942h0Zm-15.18,20.293s16.99,2.33,17.57-14.953c-0.27-16.225,20.68-17.3,26.37-5.632,0,0-14.84.194-16.4,12.429,0,0,.19,15.1-11.53,16.651,0,0-12.69,2.185-16.01-8.5h0Zm29.38-.2c6.37,12.5,22.19,10.442,25.73-.2a19.711,19.711,0,0,0,1.17-6.892v-21.8L3495.65,743v26.6s-1.12,12.719-16.55,11.943h0Zm0,0\" transform=\"translate(-3438 -737.5)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfPF.svg
// module id = ZVUw
// module chunks = 37